<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">

    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Tipo de Inversionista
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            Inversionista Institucional: persona natural que cuenta con un patrimonio superior a S/. 4 millones y un portafolio de inversiones en valores igual o superior a S/. 2 millones.
          </p>
          <p align="justify">
            Ante cualquier duda, comuníquese con su promotor.
          </p>  
        </md-card-content> 
      </md-card>   

      <md-card class="md-elevation-0 m-5"  :class="getValidationClass('inversionistaInstitucional')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          ¿Es usted un inversionista institucional? *
        </md-card-header>
        <md-card-content>
          
          <div>
            
            <div>
              <md-checkbox v-model="form.inversionistaInstitucional" value="Si" :disabled="isDisabled">Sí</md-checkbox>
              <md-checkbox v-model="form.inversionistaInstitucional" value="No" :disabled="isDisabled">No</md-checkbox>
            </div>

            <div class="radioform" :class="getValidationClass('inversionistaInstitucional')">
              <span class="md-error" v-if="!$v.form.inversionistaInstitucional.required">Esta respuesta es obligatoria.</span>
            </div>            

          </div>
        </md-card-content> 
      </md-card>         

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                


    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  props:{isDisabled: Boolean},
  name: 'Form4',
  data: () => ({
    form:{
      inversionistaInstitucional: null,
    }
  }),
  mounted: function(){
    this.form = this.$store.state.form.form4
  },  
  validations: {
    form: {
      inversionistaInstitucional: {
        required,
      },
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form4
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        this.$emit('setSaveForm', {id:"4", form: this.form, index: "5"});

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },        
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }     
}
</script>
